import React from 'react';

import { Column, Row } from 'app/shopify/components/layout';

import { Tag } from './Tag';

export function TagShowcase() {
  return (
    <Column gap="spacing.general.x3" padding="spacing.general.x4">
      <Row gap="spacing.general.x3">
        <Tag label="Tag label" type="primary" size="default" inverted />
        <Tag label="Tag label" type="primary" size="default" inverted={false} />
        <Tag label="Tag label" type="primaryNeutral" size="default" inverted={false} />
        <Tag label="Tag label" type="secondary" size="default" inverted={false} />
      </Row>

      <Row gap="spacing.general.x3">
        <Tag label="Tag label" type="primary" size="small" inverted />
        <Tag label="Tag label" type="primary" size="small" inverted={false} />
        <Tag label="Tag label" type="primaryNeutral" size="small" inverted={false} />
        <Tag label="Tag label" type="secondary" size="small" inverted={false} />
      </Row>
    </Column>
  );
}
